import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../../../../commonv3/components/atoms/buttons/Button';
import './detailsButton.module.scss';

export const DetailsButton = ({ isSp, to }) =>
    isSp ? (
        <Link key={2} styleName="link-sp" to={to}>
            課題概要を確認する
        </Link>
    ) : (
        <Button key={2} id="section-detail-button" type="normal" size="l" to={to}>
            課題概要を確認する
        </Button>
    );
